import { render, staticRenderFns } from "./FileFormModal.vue?vue&type=template&id=5f8e17ec&scoped=true&"
import script from "./FileFormModal.vue?vue&type=script&lang=js&"
export * from "./FileFormModal.vue?vue&type=script&lang=js&"
import style0 from "./FileFormModal.vue?vue&type=style&index=0&id=5f8e17ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e17ec",
  null
  
)

export default component.exports